module.exports = __webpack_public_path__ + "static/AnnieMarie-ee168ce246a809ab5d5946618725e077.jpg";